import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/img_devices.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/agile.png";
import picturequality from "./img/qualite.png";
import RightPicture from "../Section/RightPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/evolution.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";
import styles from "./Webapp.module.scss";


class Webapp extends Component {
  render() {
    let title = "Application Web";
    let goto = "En découvrir plus";
    let alt = "test";
    let description = ["Nous réalisons de superbes applications Web en associant ", <strong>vos besoins</strong>, ' avec des technologies adaptés et pérennes. Notre expertise est de vous apporter une réponse ', <strong>100% sur mesure</strong>, ' à vos demandes.'];

    let smalltitle = "Nous sommes agiles !";
    let titlemethodo = "Une méthodologie maîtrisée";
    let descriptionmethodo = ["Les projets évoluent dans le temps, le web aussi. C'est pourquoi nous avons mis en place une méthodologie adaptée à ces deux contraintes. Ainsi, avec ou sans cahier des charges, nous ", <strong>construisons ensemble</strong>, " de manière itérative et qualitative l'application dont vous avez besoin."];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";

    let smalltitleevol = "vos projets évoluent";
    let titleevol = "Des applications évolutives";
    let descriptionevol = ["Afin ", <strong>d'accompagner vos activités</strong>, " nous prenons un soin particulier à penser et concevoir des web apps qui suivront vos nouveaux besoins et vos évolutions dans le temps. Parce que nous nous engageons dans la durée, nos applications aussi."];
    let altevol = "Méthodologie agile Scrum en image";

    let descriptionTechno = "Nous sommes des experts en développement Symfony ";



    let smalltitleCheck = "La qualité n'est pas qu'un mot" ;
    let titleCheck = "Des applications de qualité";
    let subtitle1Check = "Méthodologie";
    let text1Check = "La méthodologie que nous adoptons et adaptons à tous les projets nous permet de construire ensemble l'application qui vous convient.";
    let subtitle2Check = "Tests";
    let text2Check = "Afin de proposer des développements de qualité, nous avons mis en place un cycle de développement composé de l'écriture de tests automatisés (scénarios utilisateur et tests unitaires), de test de qualité du code et de relecture du code.";
    let subtitle3Check = "Cycle itératif";
    let text3Check = "En fonction des projets, nous livrons régulièrement des fonctionnalités à tester. Cela vous permet de suivre l'avancement du projet et d'adapter certaines fonctionnalités si-nécessaires.";
    let pictureCheck = picturequality;
    let altCheck = "";


    return (
      <div className="generic-services">
        <MainPicture title="Des applications sur-mesure" description={description} picture={image} alt={alt} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />

        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <section className="web-app-techo">
          <div className="container">
              <div className="row text-center row-bottom-padded-md row-top-padded-md">
                  <div className="col">

                      <h2 className="fh5co-lead animate-box">Des technologies adaptées</h2>
                      <p className="fh5co-sub-lead animate-box">A chaque projet, nous pensons l'architecture technique <strong>en fonction de vos besoins</strong> et de votre <strong>système d'information</strong>. De plus nous intégrons les contraintes de vos services informatiques pour proposer des <strong>technologies appropriées, évolutives et pérennes</strong>.</p>
                  </div>
              </div>
          </div>
        </section>

        <section className={styles.fh5cofeatures}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12 animate-box">
                                <div className="fh5co-feature">
                                    <div className={`fh5co-icon ${styles.fh5coicon}`}><img src={symfony} alt="Logo Symfony" className="img-fluid"/></div>
                                    <h3>Symfony</h3>
                                    <p>Nous sommes experts en <strong>développement Symfony</strong>. Nous réalisons des applications Symfony qui sont évolutives et respectent les standards.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className="fh5co-feature ">
                                    <div className={` fh5co-icon ${styles.fh5coicon}`}><img src={html} alt="Logo HTML CSS JS" className="img-fluid"/></div>
                                    <h3>HTML / CSS / Javascript</h3>
                                    <p>Nous apportons un soin particulier à la réalisation d'interface graphique simple et intuitive à l'aide des technologies appropriées aux navigateurs modernes.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className="fh5co-feature">
                                    <div className={`fh5co-icon ${styles.fh5coicon}`}><img src={nodejs} alt="Logo Nodejs" className="img-fluid"/></div>
                                    <h3>NodeJS</h3>
                                    <p>En fonction des projets, NodeJS nous aide à réaliser des apps fluides, réactives et capables de répondre à un fort trafic.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={`fh5co-feature`}>
                                    <div className={`fh5co-icon ${styles.fh5coicon}`}><img src={angular} alt="Angular et React" className="img-fluid"/></div>
                                    <h3>Angular JS / React</h3>
                                    <p>Afin de proposer des applications toujours plus innovantes et adaptées aux utilisations actuelles des différents supports multimedias, nous utilisons en fonction du besoin les technologies ReactJS ou Angular.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className="fh5co-feature">
                                    <div className={`fh5co-icon ${styles.fh5coicon}`}><img src={database} alt="Angular et React" className="img-fluid"/></div>
                                    <h3>Base de données</h3>
                                    <p>En fonction de la volumétrie et de la complexité des données à traiter, nous proposons des systèmes de bases de données adaptés comme par exemple MongoDB, MariaDB ou encore Hadoop.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className="fh5co-feature">
                                    <div className={`fh5co-icon ${styles.fh5coicon}`}><img src={elasticsearch} alt="Angular et React" className="img-fluid"/></div>
                                    <h3>Moteurs de recherche</h3>
                                    <p>Parce que la facilité et la rapidité d'accès à vos données sont importantes, nous intégrons des technologies reconnues comme ElasticSearch au sein des applications.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
      </div>
    );
  }
}

export default Webapp;



// WEBPACK FOOTER //
// ./src/components/Page/Webapp.jsx